import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { clearLeftoverCognitoKeys } from "@auth/services/userPool";
import "./theme";
import "@jkast90/kast-common/base.css";
import "@jkast90/kast-common/theme.css";
import "@jkast90/kast-common/tokens.css";
import "@jkast90/kast-common/ui.css";
import "./index.css";

// Sign-ins before the in-memory pool storage left tokens in localStorage.
clearLeftoverCognitoKeys();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
